import { render, staticRenderFns } from "./ChangeAffiliateCommissionModal.vue?vue&type=template&id=046f0901"
import script from "./ChangeAffiliateCommissionModal.vue?vue&type=script&lang=js"
export * from "./ChangeAffiliateCommissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports